import {
  STATUS_URL,
  type ProviderKey,
  providers,
  ProviderPriority,
} from "@silo/types";
import { isProviderOperational } from "./is-provider-operational";

interface ProviderStatus {
  status: Status;
  priority: ProviderPriority;
}

export type Status = Record<ProviderKey, boolean>;

export async function fetchProviderStatus(): Promise<ProviderStatus> {
  const [infura, alchemy] = await Promise.all([
    fetchSingleProviderStatus(STATUS_URL.infura),
    fetchSingleProviderStatus(STATUS_URL.alchemy),
  ]);

  const status: Status = {
    infura,
    alchemy,
    /**
     * DRPC does not currently have a status page, so just hard-coding to true
     */
    drpc: true,
  };

  return {
    status,
    priority: getPriority(status),
  };
}

async function fetchSingleProviderStatus(
  atomFeedUrl: string
): Promise<boolean> {
  try {
    const response = await fetch(atomFeedUrl);

    if (response.status !== 200) {
      throw new Error(`Expected 200 status code - received ${response.status}`);
    }

    const atomFeed = await response.text();

    return isProviderOperational(atomFeed);
  } catch (error) {
    return false;
  }
}

export function getPriority(status: Status): ProviderPriority {
  const sorted = [...providers].sort((a, b) => {
    if (status[a] === status[b]) {
      return 0;
    }

    if (!status[a] && status[b]) {
      return 1;
    }

    return -1;
  });

  return sorted as unknown as ProviderPriority;
}
